import React, { useState } from "react"
import { PrismicNextImage } from "@prismicio/next"
import { isFilled, Content } from "@prismicio/client"
import Image from "next/image"
import Modal from "@aura-design/system/modal"
import { PrismicRichText } from "./prismic-richtext"
import Grid from "@aura-design/system/grid"
import { capitalizeFirstLetterRegex } from "@airplan/utils/data-view"

type CardContentProps = {
  doc: Content.CollectionRouteDocument
  state: string | null
  country: string | null
  city: string | null
}

const CardContent = ({
  state,
  country,
  city,
  airport,
  doc,
}: CardContentProps) => {
  return (
    <Grid
      col={isFilled.image(doc.data.map) ? "two" : "one"}
      className="h-full text-dark-blue"
    >
      {isFilled.image(doc.data.map) && (
        <div className="relative min-h-20">
          <PrismicNextImage
            field={doc.data.map}
            fill
            className="object-contain"
            alt=""
          />
        </div>
      )}
      <div>
        {isFilled.image(doc.data.image) && (
          <div className="text-center mod mt-1">
            <PrismicNextImage field={doc.data.image} fallbackAlt="" />
          </div>
        )}

        <div className="mt-1">
          {state && (
            <span>
              {capitalizeFirstLetterRegex(state)}
              {", "}
            </span>
          )}
          {country && <span>{capitalizeFirstLetterRegex(country)}</span>}
        </div>
        {city && (
          <div>
            <h2>{capitalizeFirstLetterRegex(city)}</h2>
          </div>
        )}
        <div>
          {airport && (
            <div>
              <h3 className="h6">{airport}</h3>
            </div>
          )}
          {isFilled.richText(doc.data.description) && (
            <PrismicRichText field={doc.data.description} />
          )}
        </div>
      </div>
    </Grid>
  )
}

type CollectionRouteProps = {
  doc: Content.CollectionRouteDocument
}

const CollectionRoute = ({ doc, ...props }: CollectionRouteProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const hasIntegrationField = isFilled.integrationField(
    doc.data.airport_destination,
  )

  const city = hasIntegrationField
    ? doc.data.airport_destination.city
    : isFilled.select(doc.data.city)
      ? doc.data.city
      : null

  const state = hasIntegrationField
    ? doc.data.airport_destination.state
    : isFilled.select(doc.data.state)
      ? doc.data.state
      : null

  const country = hasIntegrationField
    ? doc.data.airport_destination.country
    : isFilled.select(doc.data.country)
      ? doc.data.country
      : null

  const airport = hasIntegrationField
    ? `${doc.data.airport_destination.iata} - ${doc.data.airport_destination.name}`
    : isFilled.select(doc.data.airport)
      ? doc.data.airport
      : null

  return (
    <div>
      <Modal
        classNameModDetail="w-[90vw] h-[90vh]"
        isVisible={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <CardContent
          state={state}
          country={country}
          city={city}
          airport={airport}
          doc={doc}
        />
      </Modal>
      <div {...props} className="h-30 relative shadow-lg zoom mod cursor-pointer">
        <button
          className="unset "
          onClick={() => setIsOpen(true)}
          type="button"
        >
          <div>
            {isFilled.image(doc.data.image) ? (
              <PrismicNextImage
                field={doc.data.image}
                fill
                width={300}
                className="object-cover"
                alt=""
              />
            ) : (
              <Image
                src="https://images.prismic.io/airplan/Zk6wWSol0Zci9X7F_2.Rutas-RicardoPadilla.jpg?auto=format,compress"
                className="object-cover"
                alt="Ruta"
                fill
              />
            )}
          </div>
          <div className="absolute left-0 right-0 bottom-0 p-1 gradient-black">
            <div>
              {city && <span className="button-fill rounded-md">{city}</span>}
              {airport && (
                <div className="mt-1">
                  <span className="text-white">{airport}</span>
                </div>
              )}
            </div>
          </div>
        </button>
      </div>
    </div>
  )
}

export default CollectionRoute
